import {inject} from '@angular/core';
import {WcbUserService} from './user.service';

export const wcbAuthenticationGuard = () => {
    const userService = inject(WcbUserService);
    // const route = inject(ActivatedRouteSnapshot)
    return userService.isAuthenticated();
}
